import {Component, ElementRef, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppConfigService} from '../../services/config/app-config.service';
import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-api-reference-layout',
    templateUrl: './api-reference-layout.component.html',
    styleUrls: ['./api-reference-layout.component.css'],
    standalone: false
})
export class ApiReferenceLayoutComponent implements OnInit {

  env: string | null;
  isPriceStreamingPath = false;
  isTradeStreamingPath = false;
  isOpenApi = false;
  url: string | undefined;
  num: number = 4500;


  constructor(private elRef: ElementRef, private tokenStorageService: TokenStorageService, private router: Router, private appConfig: AppConfigService) {
    this.env =  this.tokenStorageService.getUserEnv();
    router.events.subscribe(event => {
      this.isTradeStreamingPath = this.router.url.includes('/aycggder8ju39-trade-streaming');
      this.isPriceStreamingPath = this.router.url.includes('/yh5fcqjesph76-price-streaming');
      this.isOpenApi = this.router.url.includes('rest-api-reference'); // ToDo: Need to change after integrate fix apis

      if (this.isTradeStreamingPath) {
        if(this.env=='asia'){
          this.url = appConfig.getAsiaConfig?.tradeStreamingUrl;
        } else {
          this.url = appConfig.getMenaConfig?.tradeStreamingUrl;
        }

      } else {
        this.url = appConfig.getCommonConfig?.priceStreamingUrl;
      }
    });

  }

  ngOnInit(): void {
    setTimeout(() => {
      const initialLoginFlagV2 = JSON.parse(localStorage.getItem('initialLoginFlagV2') || '{}');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (this.isOpenApi) {
        if (user.initialLoginFlag == 1 || initialLoginFlagV2 == 1) {
          localStorage.setItem("initialLoginFlagV2", '0');
        }
      }
    }, 1000);
  }

}
